module.exports = __webpack_public_path__ + "img/MT.23c648aa.svg";